export enum TileVariant {
  LEFT_ALIGNED = "default",
  CENTER_ALIGNED = "center",
}

export enum TileSize {
  MEDIUM = "medium",
  LARGE = "large",
}

export enum TileLinkType {
  TEXT = "text",
  BUTTON = "button",
  TEXT_BUTTON = "textButton",
}